import React, { useState, useEffect } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { getSellMaterial, setReadReqMessage } from '../../../../services/material-services';
import { useAuth } from '../../../../hooks/useAuth';
import PaginationControlled from '../../../materials/mat-pagination';
import { Button, TableHead, Typography } from '@mui/material';
import ProgressWait from '../../progress';
import DialogAnswer from '../dialog-answer';
// import { useNavigate } from 'react-router-dom';
import { blue } from '@mui/material/colors';


function ReportReqBuyDetail({filters}) {
    // const navigate = useNavigate()
    const { authData, authDataLang } = useAuth()

    const [reqBuy, setReqBuy] = useState()
    const [selectRow, setSelectRow] = useState()
    // const [error, setError] = useState(false)
    const [loading, setLoding] = useState(false)
    const [emptyRows, setEmptyRows] = useState(0)
    // const [rowsPerPage, setRowsPerPage] = useState(5)
    const [page, setPage] = useState(1)
    const [totalPage, setTotalPage] = useState(10)
    const [showPagin, setShowPagin] = useState(false)    // const [summary, setSummary] = useState(0)
    const numRows = 10
    // const totalPage = 10
    const [open, setOpen] = useState(false)

    useEffect(()=>{
        setLoding(true)
        const getData = async() =>{
            await getSellMaterial(authData?.token, page, numRows, filters)
            .then(data => {
                setReqBuy(data?.results)
                setEmptyRows(page > 0 ? Math.max(0, (1 + page) * numRows - data?.results.length) : 0)
                // console.log(data)

                const totalPTranc = Math.trunc(data?.results.count / numRows)
                const totalP = data?.results.count / numRows
                // console.log(data)
                // console.log(numRows, totalP, totalPTranc, data.count)
                
                setTotalPage(totalPTranc)
                if(totalPTranc < totalP){
                  setTotalPage(totalPTranc + 1)
                  setShowPagin(true)
                }
                
                if(totalPage > 1){
                  setShowPagin(true)
                }

                setLoding(false)
            }).catch( e => {
                // setError(true)
                setLoding(false)
            })
        }
        getData()
    }, [authData, filters])
    
    const handleNextPage = (value) => {
        // console.log(value)
        setPage(value)
        setLoding(true)
        const getData = async() =>{
          await getSellMaterial(authData?.token, value, numRows, filters)
          .then(data => {
              setReqBuy(data?.results)
              setEmptyRows(value > 0 ? Math.max(0, (1 + value) * numRows - data?.results.length) : 0)
              // console.log(data)

              const totalPTranc = Math.trunc(data?.results.count / numRows)
              const totalP = data?.results.count / numRows
              // console.log(data)
              // console.log(numRows, totalP, totalPTranc, data.count)
              
              setTotalPage(totalPTranc)
              if(totalPTranc < totalP & (totalPage > 1)){
                setTotalPage(totalPTranc + 1)
                setShowPagin(true)
              }
              
              if(totalPage > 1){
                setShowPagin(true)
              }

              setLoding(false)
          }).catch( e => {
            //   setError(true)
              setLoding(false)
          })
      }
      getData()
    }

    const handlerAnswer = value => {
        setOpen(false)
        handleNextPage(page)
    }
    
    const dataRead = async req_id => {
        setLoding(true)
        await setReadReqMessage(authData?.token, {req_id:req_id})
        .then(data =>{
            console.log("setReadReqMessage", data)
            setLoding(false)
        })
        .catch( e => {
            // setError(true)
            setLoding(false)
        })
    }

    const handleClickOpen = value => {
        setSelectRow(value)
        // console.log("handleClickOpen", value)
        dataRead(value.id)
        setOpen(true)
        // navigate('/answer-buy', {state : value});
    }

    // const openFact = (value) =>{
    //     console.log("value", value)
    //     navigate('/shopping', {state : value})
    // }
    
    // useEffect(()=>{
    //   // const result = rows?.reduce((total, currentValue) => total = total + (currentValue.sell_count * currentValue.sell_money),0)
    //   // setSummary(result)
    //     console.log("rows", rows)
    // }, [rows])

    if (loading) return <ProgressWait statusWait={true}/> 

  return (
    
      <div dir={authDataLang?.view_sts ? "rtl" : "ltr"}>
        
        <TableContainer component={Paper} sx={{backgroundColor: blue[900]}}>
          <Table sx={{ minWidth: 400 }} aria-label="custom pagination table">
          <TableHead>
              <TableRow >
                  <TableCell scope="row">
                      <Typography
                          fontFamily='b_mitra' 
                          component="div"
                          variant="h6"
                          color={'white'}
                          >
                          نام کاربر
                      </Typography>
                  </TableCell>
                  <TableCell align="left">
                      <Typography
                          fontFamily='b_mitra' 
                          component="div"
                          variant="h6"
                          color={'white'}
                          >
                          تلفن کاربر
                      </Typography>
                  </TableCell>
                  <TableCell align="left">
                      <Typography
                          fontFamily='b_mitra' 
                          component="div"
                          variant="h6"
                          color={'white'}
                          >
                          موضوع
                      </Typography>
                  </TableCell>
                  <TableCell align="left">
                      <Typography
                          fontFamily='b_mitra' 
                          component="div"
                          variant="h6"
                          color={'white'}
                          >
                          توضیحات
                      </Typography>
                  </TableCell>
                  <TableCell align="left">
                      <Typography
                          fontFamily='b_mitra' 
                          component="div"
                          variant="h6"
                          color={'white'}
                          >
                          عملیات
                      </Typography>
                  </TableCell>
                </TableRow>
          </TableHead>

            <TableBody sx={{ minWidth: 400, backgroundColor:'pink.text' }}>
              {reqBuy && reqBuy?.map((row) => (
                    <TableRow key={row.id}>
                        <TableCell scope="row">
                            <Typography
                                fontFamily='b_mitra' 
                                component="div"
                                variant={row?.req_status===0 ? "h6" : "div"}
                                color={row?.req_status===0 ? blue[900] : blue[700]}
                                >
                                {row?.user?.last_name}
                            </Typography>
                        </TableCell>
                        <TableCell align="left">
                            <Typography
                                fontFamily='b_mitra' 
                                component="div"
                                variant={row?.req_status===0 ? "h6" : "div"}
                                color={row?.req_status===0 ? blue[900] : blue[700]}
                                >
                                {row?.user?.profile?.phone_user}
                            </Typography>
                        </TableCell>
                        <TableCell align="left">
                            <Typography
                                fontFamily='b_mitra' 
                                component="div"
                                variant={row?.req_status===0 ? "h6" : "div"}
                                color={row?.req_status===0 ? blue[900] : blue[700]}
                                >
                                {row?.job_detail}
                            </Typography>
                        </TableCell>
                        <TableCell align="left">
                            <Typography
                                fontFamily='b_mitra' 
                                component="div"
                                variant={row?.req_status===0 ? "h6" : "div"}
                                color={row?.req_status===0 ? blue[900] : blue[700]}
                                >
                                {row?.remarks}
                            </Typography>
                        </TableCell>
                        <TableCell align="left">
                            <Button 
                                variant="contained" 
                                color="primary"
                                size="small" 
                                onClick={() => handleClickOpen(row)}
                                >
                                <Typography
                                    fontFamily='b_mitra' 
                                    component="div"
                                    variant="h6"
                                    color={row?.req_status===0 ? blue[50] : blue[200]}
                                    >
                                    جواب
                                </Typography>
                            </Button>
                        </TableCell>
                    </TableRow>
              ))}
              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        {showPagin &&
            <div style={{width: '100%', display: 'block', textAlign: 'center'}}>
                <PaginationControlled onChange={handleNextPage} pageNow={page} totalCount={totalPage}/>
            </div>
        }
        {selectRow &&
            <DialogAnswer selectedValue={selectRow} open={open} onClose={handlerAnswer}/>
        }
      </div>
  )
}

export default ReportReqBuyDetail
